import { render } from "./sheet-buy-pro.vue?vue&type=template&id=24a8794b"
import script from "./sheet-buy-pro.vue?vue&type=script&lang=js"
export * from "./sheet-buy-pro.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__